import * as React from 'react';

const Unchecked = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x="2.5" y="6.5" width="11" height="11" stroke="currentColor" />
    </svg>
);

export default Unchecked;
